@for( sport of optionsSports; track sport.sport ){
<div class="relative pb-5 text-center text-12 w-fit max-sm:pb-3 text-nowrap">
  <div
    class="flex flex-col items-center gap-y-1.5"
    [class.torito]="sport.sport === 'Ganadazo'"
  >
    <img
      alt="sport-icon"
      [src]="generateImageUrl(sport)"
      [ngClass]="{
        'max-sm:w-[20px] max-h-[25px] max-sm:max-h-[20px]':
          sport.sport !== 'Ganadazo'
      }"
    />
    <div>{{ sport.text }}</div>
  </div>
  @if(sport.selected){
  <div class="selected"></div>
  }
</div>
}
